import { createRouter, createWebHashHistory } from 'vue-router';
import { isChunkLoadError, shouldReloadFor, clearReloadMark } from '../utils/staleChunk';

const Landing = () => import(/* webpackChunkName: "landing" */ '../components/Landing.vue');
const GameBoard = () => import(/* webpackChunkName: "game" */ '../components/game/GameBoard.vue');
const CreateGame = () => import(/* webpackChunkName: "lobby" */ '../components/lobby/CreateGame.vue');
const JoinGame = () => import(/* webpackChunkName: "lobby" */ '../components/lobby/JoinGame.vue');

const routes = [
  { path: '/', name: 'landing', component: Landing },
  { path: '/game', name: 'game', component: GameBoard }, // local (hotseat / solo-vs-AI)
  { path: '/new', name: 'new-remote-game', component: CreateGame },
  { path: '/join/:code?', name: 'join-remote-game', component: JoinGame, props: true },
  { path: '/game/:gameId', name: 'remote-game', component: GameBoard, props: true }, // remote (Firebase-synced)
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
});

// A lazy screen whose chunk a deploy deleted - see utils/staleChunk.js for
// the "Start game just puts the banner back" report this answers.
router.onError((error, to) => {
  if (!isChunkLoadError(error) || !to) return;
  const href = router.resolve(to).href;
  if (!shouldReloadFor(href)) return;
  window.location.assign(href);
  window.location.reload();
});
router.afterEach(() => clearReloadMark());

export default router;
